import {tagEquals, TagModel} from './BaseTagModel';
import {SOURCE_USERGENERATED} from '../../constants/tags';

/**
 * Used to denote which tags are provided by the backend
 */
export const UserGeneratedTagModel = TagModel.extend({
    idAttribute: 'uuid',
    blacklist: ['included'],
    defaults: () => ({
        included: true,
        userGenerated: true,
        weight: 1,
        source: SOURCE_USERGENERATED,
    }),
    equals(tag) {
        return tagEquals(this, tag);
    },
    /**
     * Using this to force set values for User Generated Tags
     *
     * @param {Object} attrs
     * @param {Object} __options
     */
    preinitialize(attrs, __options) {
        attrs.userGenerated = true;
        attrs.weight = 1;
        attrs.source = SOURCE_USERGENERATED;
    },
    getIsOrderable() {
        return true;
    },
});

UserGeneratedTagModel.of = (...args) => new UserGeneratedTagModel(...args);

export default UserGeneratedTagModel;